// Catalogue of the Explore › Statistics pages (recreating the Handbook
// "removed functionality"). The autonomous build loop flips `ready: true`
// and adds the route as each page is implemented. `slug` is both the route
// segment (/explore/stats/<slug>) and the backend endpoint name.
//
// `thumbnailKind` tells the hub how to render the tile's preview chart
// (see StatThumbnail.js); the data shape is decided by the backend
// `/api/explore/stats/hub-previews` extractor for that slug.

export const STAT_SECTIONS = [
  {
    section: 'Sitting Patterns',
    pages: [
      { slug: 'sitting-patterns', title: 'Sitting pattern statistics', ready: true, thumbnailKind: 'line' },
      { slug: 'sitting-day-length', title: 'Sitting day length', ready: true, thumbnailKind: 'line' },
    ],
  },
  {
    section: 'Floor time',
    pages: [
      { slug: 'time-on-business', title: 'What did Parliament spend its time on?', ready: true, thumbnailKind: 'bar' },
      { slug: 'bills-on-the-floor', title: 'Bills on the floor', ready: true, thumbnailKind: 'bar' },
      { slug: 'outcomes-ledger', title: 'Outcomes ledger', ready: true, thumbnailKind: 'bar' },
    ],
  },
  {
    section: 'Question Time',
    pages: [
      { slug: 'qt-overview', title: 'QT in numbers', ready: true, thumbnailKind: 'bar' },
      { slug: 'qt-portfolios', title: 'Portfolio heatmap', ready: true, thumbnailKind: 'bar' },
      { slug: 'qt-interjections', title: 'Interjection meter', ready: true, thumbnailKind: 'line' },
      { slug: 'qt-people', title: 'Top askers and responders', ready: true, thumbnailKind: 'bar' },
      { slug: 'qt-length', title: 'Question and answer length', ready: true, thumbnailKind: 'line' },
      { slug: 'qt-clock', title: 'QT time-of-day', ready: true, thumbnailKind: 'line' },
    ],
  },
  {
    section: 'Parliamentarian demographics',
    pages: [
      { slug: 'gender-composition', title: 'Gender composition in each Parliament', ready: true, thumbnailKind: 'stacked' },
      { slug: 'age-groups', title: 'Age groups and distribution', ready: true, thumbnailKind: 'bar' },
      { slug: 'parliamentarian-ages', title: 'Parliamentarian ages over time', ready: true, thumbnailKind: 'line' },
      { slug: 'overseas-born', title: 'Overseas born', ready: true, thumbnailKind: 'bar' },
      { slug: 'fields-of-qualifications', title: 'Fields of qualifications — current Parliament', ready: true, thumbnailKind: 'bar' },
      { slug: 'levels-of-qualifications', title: 'Levels of qualifications — current Parliament', ready: true, thumbnailKind: 'bar' },
      { slug: 'previous-occupations', title: 'Previous occupations — current Parliament', ready: true, thumbnailKind: 'bar' },
      { slug: 'length-of-service-groups', title: 'Length of service groups and distribution', ready: true, thumbnailKind: 'bar' },
      { slug: 'periods-of-service', title: 'Periods of service — current Parliament', ready: true, thumbnailKind: 'card' },
      { slug: 'women-in-parliament', title: 'List of all women in Parliament', ready: true, thumbnailKind: 'card' },
      { slug: 'longest-serving-members', title: 'Longest serving members (over 20 years)', ready: true, thumbnailKind: 'card' },
      { slug: 'first-nations', title: 'Aboriginal and/or Torres Strait Islander Parliamentarians', ready: true, thumbnailKind: 'bar' },
      { slug: 'military-service', title: 'Military service of parliamentarians', ready: true, thumbnailKind: 'bar' },
      { slug: 'changed-electorate', title: 'Parliamentarians who changed electorate', ready: true, thumbnailKind: 'card' },
      { slug: 'prior-elected-service', title: 'Prior elected service in government — current Parliament', ready: true, thumbnailKind: 'bar' },
      { slug: 'both-chambers', title: 'Members in both chambers', ready: true, thumbnailKind: 'bar' },
      { slug: 'first-most-more', title: 'First, Most and More — records hub', ready: true, thumbnailKind: 'card' },
    ],
  },
  {
    section: 'Parties',
    pages: [
      { slug: 'party-representation', title: 'Party representation in each parliament', ready: true, thumbnailKind: 'line' },
      { slug: 'party-representation-by-state', title: 'Party representation by state — current Parliament', ready: true, thumbnailKind: 'bar' },
      { slug: 'parliamentary-party-statistics', title: 'Parliamentary party statistics', ready: true, thumbnailKind: 'card' },
      { slug: 'party-timeline', title: 'Party timeline — start and end dates', ready: true, thumbnailKind: 'card' },
      { slug: 'changed-parties', title: 'Parliamentarians who changed parties', ready: true, thumbnailKind: 'line' },
    ],
  },
  {
    section: 'Committees',
    pages: [
      { slug: 'committee-statistics', title: 'Committee statistics', ready: true, thumbnailKind: 'card' },
      { slug: 'committee-membership', title: 'Committee membership statistics', ready: true, thumbnailKind: 'bar' },
    ],
  },
  {
    section: 'Divisions',
    pages: [
      { slug: 'division-statistics', title: 'Division statistics', ready: true, thumbnailKind: 'stacked' },
    ],
  },
  {
    section: 'Legislation',
    pages: [
      { slug: 'legislation-passage', title: 'Legislation passage statistics', ready: true, thumbnailKind: 'line' },
    ],
  },
  {
    section: 'Ministerial statements',
    pages: [
      { slug: 'ministerial-statements', title: 'Ministerial statement statistics', ready: true, thumbnailKind: 'line' },
    ],
  },
  {
    section: 'Leadership',
    pages: [
      { slug: 'prime-ministers', title: 'Prime Ministers', ready: true, thumbnailKind: 'bar' },
      { slug: 'opposition-leaders', title: 'Leaders of the Opposition', ready: true, thumbnailKind: 'bar' },
      { slug: 'speakers', title: 'Speakers of the House of Representatives', ready: true, thumbnailKind: 'bar' },
      { slug: 'presidents', title: 'Presidents of the Senate', ready: true, thumbnailKind: 'bar' },
      { slug: 'office-holders', title: 'Parliamentary office holders', ready: true, thumbnailKind: 'bar' },
    ],
  },
  {
    section: 'Reference',
    pages: [
      { slug: 'royal-commissions', title: 'Royal Commissions', ready: true, thumbnailKind: 'line' },
      { slug: 'heads-of-state', title: 'Heads of state since Federation', ready: true, thumbnailKind: 'bar' },
    ],
  },
  {
    section: 'Elections & voting',
    pages: [
      { slug: 'casual-vacancies', title: 'Senate casual vacancies', ready: true, thumbnailKind: 'bar' },
      { slug: 'referendums', title: 'Referendums + plebiscites', ready: true, thumbnailKind: 'stacked' },
      { slug: 'elections', title: 'Federal elections + by-elections', ready: true, thumbnailKind: 'line' },
    ],
  },
];
